import { BaseModel } from "../base.model";

export class FFTagoviDto extends BaseModel {
    sifra: number;
    naziv: string;
}